import React from "react";
import {Segment} from "semantic-ui-react";
import {FormattedHTMLMessage as MSGS} from "react-intl";
import {AccountItem} from "../view/CommonPage";
import CardFromToAccount from "./CardFromToAccount";

interface IProperties {
    batchDetails : Array<IBatch>
}

interface IBatch {
    reference: string
    paymentDetails: Array<IPayment>
}

interface IPayment {
    amount: number
    currency: string
    creditorAccount: AccountItem
    debtorAccount?: AccountItem
    exchangeRate?: number
    charge?: {
        currency: string
        amount: number
        vatAmount?: number
        chargeBearer: string
        message?: string
    }
}

/**
 * Карточка, отображающая информацию о группе платежей, которые проходят авторизацию.
 */
export default class CardBulkPayment extends React.Component<IProperties> {

    render()
    {
        let batches = this.props.batchDetails.map(item => <CardBatch key={item.reference} batch={item}/>)
        return (
            <div>
                <div className={"app-text"}><MSGS id="welcome_page_bulk_payment_consent_first_line"/></div>
                {batches}
            </div>
        )

    }
}

class CardBatch extends React.Component<{batch: IBatch}>
{
    render()
    {
        let payments = this.props.batch.paymentDetails.map((item, count) => <CardBatchPayment key={count} payment={item}/>)
        return (
        <div>
            <div className={"app-text"}>{this.props.batch.reference}</div>
            {payments}
        </div>
        )
    }
}

class CardBatchPayment extends React.Component<{payment: IPayment}> {
    render()
    {
        let chargesSegment;
        let messageSegment;
        if (this.props.payment.charge)
        {
            let chargeBearerText;
            if (this.props.payment.charge.chargeBearer ==='DEBT')
            {
                chargeBearerText = 'welcome_page_payment_consent_charge_bearer_our';
            }
            else if (this.props.payment.charge.chargeBearer ==='CRED')
            {
                chargeBearerText = 'welcome_page_payment_consent_charge_bearer_ben';
            }
            else 
            {
                chargeBearerText = 'welcome_page_payment_consent_charge_bearer_sha';
            }

            let vatSegment;
            if (this.props.payment.charge.vatAmount)
            {
                vatSegment = <div className={"app-subtext"} key={"paymentAmount"}> {<MSGS id="welcome_page_consent_vat_amount"/>} {this.props.payment.charge.vatAmount} {this.props.payment.charge.currency}</div>
            }

            if (this.props.payment.charge.message)
            {
                messageSegment = <div className={"app-subtext"}><MSGS id={this.props.payment.charge.message}/></div>
            }

            chargesSegment = 
            <Segment>
                <div className={"app-subtext"}> {<MSGS id="welcome_page_payment_consent_charges"/>}</div>
                <div className={"app-subtext"}><MSGS id="welcome_page_consent_charge_amount" />{this.props.payment.charge.amount} {this.props.payment.charge.currency}</div>
                {vatSegment}
                <div className={"app-subtext"}><MSGS id={chargeBearerText}/></div>
            </Segment>
        }

        return (
            <div>
                <Segment>
                <div className={"app-text"}>{this.props.payment.amount} {this.props.payment.currency}</div>
                {chargesSegment}
                <Segment>
                        <CardFromToAccount debtorAccount={this.props.payment.debtorAccount} creditorAccount={this.props.payment.creditorAccount}/>
                </Segment>
                {messageSegment}
                </Segment>
            </div>
        )
    }
}